
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/events",
      function () {
        return require("private-next-pages/[domain]/events/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/events"])
      });
    }
  